"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const formik_1 = require("formik");
const RenderSelectField = (props) => {
    const { field: { value, name, onChange, onBlur }, form: { touched, errors, setFieldTouched, submitCount }, label, placeholder, options, onValueChange = () => undefined, emptyOption, ...otherProps } = props;
    const error = formik_1.getIn(errors, name);
    const touch = formik_1.getIn(touched, name);
    const displayErrors = (touch || submitCount > 0) && !!error;
    const handleChange = (event) => {
        onChange(event);
        onValueChange(event.target.value);
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Box_1.default, null,
            react_1.default.createElement(TextField_1.default, Object.assign({ name: name, select: true, fullWidth: true, label: label, variant: "outlined", inputProps: { displayEmpty: true, onClose: () => setFieldTouched(name, true) }, error: touch && !!error, value: value || '', onChange: handleChange, onBlur: onBlur }, otherProps),
                emptyOption && react_1.default.createElement(MenuItem_1.default, null, "None"),
                options.map((option, key) => (react_1.default.createElement(MenuItem_1.default, { key: key, value: option.value, disabled: option === null || option === void 0 ? void 0 : option.disabled }, option.label))),
                !options.length && react_1.default.createElement(MenuItem_1.default, null, "No options")),
            displayErrors && (react_1.default.createElement(Typography_1.default, Object.assign({ variant: "body2", component: "p", color: "error" }, otherProps), error)))));
};
RenderSelectField.defaultProps = {
    emptyOption: false,
};
RenderSelectField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string.isRequired,
    placeholder: prop_types_1.default.string,
    options: prop_types_1.default.array.isRequired,
    onValueChange: prop_types_1.default.func,
    emptyOption: prop_types_1.default.bool,
};
exports.default = RenderSelectField;
